export default "__VITE_ASSET__BJGgYEMo__"